import { hasStatusCode } from "@app.raytd.com/store";

/**
 * Get the HTTP status code from an RTK Query error if available
 * @param error - The error object from RTK Query
 * @returns The status code or undefined if not available
 */
export function getRtkStatus(error: unknown): number | undefined {
  if (hasStatusCode(error)) {
    return error.status;
  }
  return undefined;
}

/**
 * Check if an RTK Query error has a specific status code
 * @param error - The error object from RTK Query
 * @param code - The HTTP status code to check for
 * @returns True if the error has the specified status code
 */
export function isRtkStatus(error: unknown, code: number): boolean {
  const status = getRtkStatus(error);
  return status === code;
}

